<template>
    <div class="footer">
        <div class="title">我们致力于以用户场景为切入点，以产品体验为核心，以高并发技术为工具帮助合作伙伴实现数字化转型与企业信息化建设</div>
        <div class="ipt-con">
            <el-input placeholder="输入你的Email"/>
            <el-button type="primary">联系我们</el-button>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    .footer{
        width: 100%;
        min-height: 416px;
        background-image: url("https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs5/bg.png");
        background-position: center top;
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
            font-size: 34px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 51px;
            text-align: center;
            width: 980px;
            padding-top: 61px;
        }
        .ipt-con{
            position: relative;
            margin-top: 50px;
            .el-input{
                width: 508px;
                height: 57px;
                background: #FFFFFF;
                box-shadow: 0px 9px 38px 0px rgba(255,176,158,0.12);
                border-radius: 5px;
            }
            .el-button{
                width: 164px;
                height: 47px;
                background: #92D749;
                border-radius: 5px;
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translate(0, -50%);
            }
        }
    }
</style>